import PlayAudioContainer from './play-audio.container'

export default PlayAudioContainer
